import React from 'react'
import { FormattedMessage } from 'react-intl'

const hoursInDay = 24
const daysInWeek = 7
const hoursInWeek = hoursInDay * daysInWeek
const dayRoundsUpAt = hoursInDay / 2
const HOURS_ROUND_TO_WEEK = hoursInWeek - dayRoundsUpAt

const TimeFrame = ({ hours }) => {
  const useHours = hours ? parseInt(hours, 10) : 0

  if (isNaN(useHours) || useHours <= 0) {
    return <FormattedMessage id='MortgageCoach.confirmTCA.timeFrame.none' defaultMessage='soon' />
  }

  if (useHours === 1) {
    return <FormattedMessage id='MortgageCoach.confirmTCA.timeFrame.1hour' defaultMessage='in about an hour' />
  } else if (useHours < 24) {
    return (
      <FormattedMessage
        id='MortgageCoach.confirmTCA.timeFrame.hours'
        defaultMessage='in about {hours} hours'
        values={{ hours: useHours }}
      />
    )
  } else if (useHours < 48) {
    return <FormattedMessage id='MortgageCoach.confirmTCA.timeFrame.1day' defaultMessage='in about a day' />
  } else if (useHours < HOURS_ROUND_TO_WEEK) {
    return (
      <FormattedMessage
        id='MortgageCoach.confirmTCA.timeFrame.days'
        defaultMessage='in about {days} days'
        values={{ days: Math.round(hours / 24) }}
      />
    )
  } else if (useHours >= HOURS_ROUND_TO_WEEK) {
    return <FormattedMessage id='MortgageCoach.confirmTCA.timeFrame.week' defaultMessage='in about a week' />
  }
}

export default TimeFrame
